(ns quuppa.qsm.planner.events
  (:require [re-frame.core :as rf]
            [quuppa.peweb.query :as q]
            [ajax.core :as ajax]
            [day8.re-frame.http-fx]))

(def plans-query (q/create-query :planner/list-plans []))
(def plan-query (q/create-query :planner/get-plan [:id]))

(rf/reg-event-db :planner/plan-updated
  (fn [db [_ result :as event]]
    (-> db
        ((q/update-event-fn plan-query (fn [_result qpe]
                                         qpe))
         event)
        (assoc-in [:site-plan (:id result)] result))))

(rf/reg-event-fx ::plan-loaded
  (fn [{:keys [db]} [_ plan-id]]
    {:db (assoc-in db [:site-plan plan-id] (:result (q/get-result db plan-query {:id plan-id})))}))

(rf/reg-event-fx ::init-new-plan
  (fn [{:keys [db]} _]
    {:fx [[:dispatch [:nav/push-state :planner-new-plan]]]
     :db (assoc db :site-plan {:new {:nodes {"root" {:type "Root"
                                                     :properties {:name "Unnamed site plan"}
                                                     :children []}}
                                     :resources {}}})}))

(rf/reg-event-fx ::add-node
  (fn [{:keys [db]} [_ plan-id parent-id node-type]]
    (let [id (str (random-uuid))
          new-node {:type node-type
                    :properties {:id id
                                 :name ""}
                    :children []}]
      {:db (-> db
               (update-in [:site-plan plan-id :nodes parent-id] update :children conj id)
               (update-in [:site-plan plan-id :nodes] assoc id new-node))
       :fx [[:update-query [assoc :selected id]]]})))

(defn remove-node [nodes node-id]
  ;; Remove children of the node being removed
  (let [{:keys [children]} (get nodes node-id)]
    (->> (reduce remove-node
                 ;; Remove this node
                 (dissoc nodes node-id)
                 children)
         ;; Remove references to this node
         (map (fn [[id node]]
                [id (if (map? node)
                      (assoc node :children (vec (remove #(= % node-id) (:children node))))
                      node)]))
         (into (empty nodes)))))

(rf/reg-event-db ::remove-node
  (fn [db [_ plan-id node-id]]
    (-> db (update-in [:site-plan plan-id :nodes] remove-node node-id))))

(rf/reg-event-db ::assoc-property
  (fn [db [_ plan-id node-id property value]]
    (-> db
        (assoc-in [:site-plan plan-id :nodes node-id :properties property] value))))

(rf/reg-event-fx ::set-image-resource
  (fn [_ [_ plan-id node-id blob]]
    {:fx [[:http-xhrio {:method          :post
                        :uri             "/planner/files"
                        :body            (doto (js/FormData.)
                                           (.append "file" blob))
                        :on-success      [::image-uploaded plan-id node-id]
                        :on-failure      [::image-upload-error]
                        :response-format (ajax/json-response-format {:keywords? true})}]]}))

(rf/reg-event-fx ::image-uploaded
  (fn [{:keys [db]} [_ plan-id node-id resp]]
    {:db (-> db
             (assoc-in [:site-plan plan-id :nodes node-id :properties :image] (:file_id resp)))}))

(rf/reg-event-fx ::save-plan
  (fn [{:keys [db]} [_ plan-id]]
    (let [plan (-> db
                   :site-plan
                   (get plan-id)
                   (select-keys [:nodes]))]
      (if (= :planner-new-plan (-> db :quuppa.routing/match :data :name))
        {:fx [[:server-dispatch {:event      [:planner/create-plan plan]
                                 :on-success [::plan-created]}]]}
        {:fx [[:server-dispatch {:event      [:planner/save-plan (assoc plan :id (-> db :quuppa.routing/match :parameters :path :plan-id))]
                                 :on-success [::plan-saved plan-id]}]]}))))

(rf/reg-event-fx ::plan-created
  (fn [_ [_ resp]]
    {:fx [[:push-state [:planner-site-plan {:plan-id (:id resp)}]]]}))

(rf/reg-event-fx ::plan-saved
  (fn [{:keys [db]} [_ plan-id _resp]]
    {:db (update db :site-plan dissoc plan-id)}))

